
import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser";
import { IonContent, LoadingController, NavParams, Platform, PopoverController } from "@ionic/angular";
import { fromEvent, Subscription } from "rxjs";
import { Navigator } from "src/app/services/routing/navigator";
import { BannerService } from "src/app/services/banner/banner.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { DepositService } from "src/app/services/cashier/deposit.service";
import { isUndefined } from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { DepositMainLabels } from "../cashier-models/interfaces";

import { InstaModel } from "../cashier-models/models";
import { RoutingService } from "src/app/services/routing/routing.service";


@Component({
  selector: "page-deposit-idebit",
  templateUrl: "deposit-idebit-action.html",
})
export class DepositIdebitActionPage extends CashierBase implements OnInit {
  @ViewChild("Content") content: IonContent;

  private amount: number;
  private bonusID: string;
  private bonusCode: string;
  private paymentRequestID;
  private iframe_url;

  public isMobile;

  public check_deposit_complete: boolean = false;
  public check_deposit_result: string;
  public loading: boolean = true;
  public idebitCallBack: Subscription;

  constructor(
    private cashierProvider: CashierService,
    private config: ConfigService,
    private depositService: DepositService,
    private navigator: Navigator,
    private routing: RoutingService,
    private sanitizer: DomSanitizer,
    protected bannerProvider: BannerService,
    protected events: EventsService,
    protected navParams: NavParams,
    protected userSessionProvider: UserSessionService,
    protected utils: UtilsService,
    public platform: Platform,
  ) {
    super();

    this.amount = this.navParams.get("amount");
    this.paymentRequestID = this.navParams.get("paymentRequestID");
    this.bonusCode = this.navParams.get("bonusCode");
    this.bonusID = this.navParams.get("bonusID");

    this.idebitCallBack = fromEvent(window, 'message').subscribe((event: any) => {
      if (event.data.id) {
        this.checkDeposit(event.data.id);
        this.unsubscribe();
      }
    });
  }

  ngOnInit() {
    this.userSessionProvider.getCustomer().subscribe((customer) => {
      let params = {
        merchant_id: this.config.getConfig().IDEBIT_MERCHANT_ID,
        merchant_user_id: customer.customerId,
        txn_currency: this.config.getConfig().DEFAULT_CURRENCY,
        merchant_txn_num: this.paymentRequestID,
        txn_amount: this.amount,
        merchant_sub_id: this.config.getConfig().IDEBIT_MERCHANT_SUB_ID,
        return_url: encodeURIComponent(
          `${this.config.getConfig().LOBBY_URL
          }/assets/static/deposit_script.html?paymentRequestID=${this.paymentRequestID
          }#idebit-return`
        ),
      };

      let queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      this.iframe_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.config.getConfig().WEBSERVICES_URL
        }/external/idebit-post?${queryString}`
      );
    });
  }

  ionViewDidLoad() {
    this.isMobile = (this.platform.is('cordova')) ? true : false;
  }

  loadiFrame() {
    this.loading = true;
    setTimeout(
      () => {
        this.loading = false;
      }, 1000);
  }

  checkDeposit(paymentRequestId) {
    if (!isUndefined(paymentRequestId)) {
      this.depositService.checkDepositStatus(paymentRequestId).subscribe(
        (response) => {
          this.check_deposit_complete = true;
          console.log(response);
          if (!isUndefined(response.payload)) {
            switch (response.payload.status) {
              case 'APPROVED':
                /*let depositEventData: AffiliateTrackerCallbackParams = {
                  customer_id: this.cashierProvider.customer.customerId,
                  amount: this.amount,
                  paymentMethod: "iDEBIT"
                }
                setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);*/
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  { status: true }
                );
                break;
              case 'IN PROCESS':
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  {
                    status: false,
                    message:
                      "Your deposit transaction is still in progress.<br/>Please check your account or contact customer support.",
                  }
                );
                break;
              case 'CANCELLED':
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  {
                    status: false,
                    message:
                      "Your deposit transaction did not succeed.",
                  }
                );
                break;
              default:
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  {
                    status: false,
                    message:
                      "Your deposit transaction could not be processed.",
                  }
                );
                break;
            }
          } else {
            //this.check_deposit_result = 'FAIL'
            this.navigator.navigateTo(
              "DepositSuccessFailureComponent",
              {},
              { status: false }
            );
          }
        },
        (error) => {
          //this.check_deposit_complete = true;
          //this.check_deposit_result = 'FAIL'
          this.navigator.navigateTo(
            "DepositSuccessFailureComponent",
            {},
            { status: false }
          );
        }
      );
    } else {
      //this.check_deposit_complete = true;
      //this.check_deposit_result = 'FAIL'
      this.navigator.navigateTo(
        "DepositSuccessFailureComponent",
        {},
        { status: false }
      );
    }
  }

  closeDialog() {
    this.routing.defaultRoute();
  }

  onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
      let navigateBackPage = this.navParams.get("navigateBackPage");
      this.navigator.navigateTo(navigateBackPage);
    } else {
      this.navigator.back();
    }
  }

  unsubscribe() {
    this.idebitCallBack.unsubscribe();
  }
}
